import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class ScriptFormatter extends Formatter {
}

// Каталог SSH-скриптов (read + редактирование label, authorized/admin/scripts).
export default class ApiScript extends ApiModelWithAuth {
    pathDef = 'authorized/admin/scripts';
    formatterItem = ScriptFormatter.Item;
}
